import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import ApproveRejectClaimForm, {
    ApproveRejectClaimFormProps
} from "../../../pages/reimbursements/components/claims/ApproveRejectClaimForm";
import SlideOver, {SlideOverProps} from '../../generic/SlideOver';


interface OwnProps extends SlideOverProps, ApproveRejectClaimFormProps {
}

type Props = OwnProps;

// @ts-ignore
const ApproveRejectClaimModal = NiceModal.create<Props>(({reimbursementClaimId, reimbursementClaimApproval, onClose, header,...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <ApproveRejectClaimForm reimbursementClaimId={reimbursementClaimId} reimbursementClaimApproval={reimbursementClaimApproval} {...rest}/>
        </SlideOver>
    )
})

export default ApproveRejectClaimModal;
